<template>
	<div class="ContactUs">

		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
			<!-- 标题 -->
			<div slot="headerTitle">{{$store.state.navShow == true ?'安全快捷、真情服务':'Effective and safe, sincere service'}}</div>
			<!-- 			<div style="font-size: 1.125rem; color: #FFFFFF; font-weight: 100; margin-top: 0.6rem;" slot="headerTitle">
				为国际贸易提供“外链”增值服务</div> -->
		</Header>

		<div class="TopTitle" data-aos="fade-right">
			<!-- data-aos="fade-up-left" -->
			<div class="">
				{{$store.state.navShow == true ? $route.name : $route.meta.EnName}}

			</div>
		</div>

		<div class="ContentContactUs">
			<div class="main_items" v-for="(item,index) in $store.state.navShow == true ? item_detailsArr :item_detailsArrE" :key="index">
				<div class="items_title">
					<div class="title_l">
						<div class="rowLine"></div>
						<p>{{item.name}}</p>
					</div>
					<div class="title_r">
						<img :src="item.thumb" alt="">
					</div>
				</div>
				<div class="item_details">
					<div class="weizhi">
						<img src="../../assets/contactUs/weizhi.png" alt="">
						<p class="pFont">{{item.address}}</p>
					</div>
					<!-- 邮箱 -->
					<div v-if="item.email" class="emails">
						<img src="../../assets/contactUs/youxiang.png" alt="">
						<p class="pFont">{{item.email}}</p>
					</div>

					<div v-if="item.phone" class="phones">
						<img src="../../assets/contactUs/phone.png" alt="">
						<p>{{item.phone}}</p>
					</div>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import Header from "@/components/header.vue";
	export default {
		components: {
			Header,
		},
		data() {
			return {
				imgList: {
					bannerImg: require('@/assets/contactUs/banner.jpg'),
					// backgroundImg: require('@/assets/chinaAndRussia/backgroundImg.png'),
					// currency: require('@/assets/OverseasWarehouse/currency.png'),
					bottonImg: require('@/assets/OverseasWarehouse/currency.png'),
				},
				item_detailsArr: [{
						name: '河北',
						thumb: require('@/assets/contactUs/hebei.png'),
						address: '河北省石家庄市裕华区体育南大街399号4层',
						email: 'YSY@MARGINGROUP.CN',
						phone: '0311-8695-8033'
					},
					{
						name: '上海',
						thumb: require('@/assets/contactUs/shanghai.png'),
						address: '上海市浦东大道720号国际金融航运大厦2楼',
						email: 'MGGROUP_EVA@163.com',
						phone: '021-205-15135'
					},
					{
						name: '圣彼得堡',
						thumb: require('@/assets/contactUs/shengbidebao.png'),
						address: 'St. Petersburg, Karl Faberge Square, 8B',
						email: 'OFFICE@mLOGISTIC.SU',
						phone: '+7(812)448-16-36'
					},

					{
						name: '海参崴',
						thumb: require('@/assets/contactUs/haishenwei.png'),
						address: 'Vladivostok, Berezova Street, 25, office 418',
						email: 'PS@mLOGISTIC.SU.COM',
						phone: '+7(423)200-62-06'
					}
				],
				item_detailsArrE: [{
						name: '河北',
						thumb: require('@/assets/contactUs/hebei.png'),
						address: '河北省石家庄市裕华区体育南大街399号4层',
						email: 'YSY@MARGINGROUP.CN',
						phone: '0311-8695-8033'
					},
					{
						name: '上海',
						thumb: require('@/assets/contactUs/shanghai.png'),
						address: '上海市浦东大道720号国际金融航运大厦2楼',
						email: 'MGGROUP_EVA@163.com',
						phone: '021-205-15135'
					},
					{
						name: '圣彼得堡',
						thumb: require('@/assets/contactUs/shengbidebao.png'),
						address: 'St. Petersburg, Karl Faberge Square, 8B',
						email: 'OFFICE@mLOGISTIC.SU',
						phone: '+7(812)448-16-36'
					},

					{
						name: '海参崴',
						thumb: require('@/assets/contactUs/haishenwei.png'),
						address: 'Vladivostok, Berezova Street, 25, office 418',
						email: 'PS@mLOGISTIC.SU.COM',
						phone: '+7(423)200-62-06'
					}
				],


			}
		},
		mounted() {
			//  联系我们seo与公司地标
			this.$axios.get('/api/Contactus/index').then(res => {
				console.log('联系我们=>', res)
				if (res.data.code === 1) {
					// 标题
					document.title = res.data.data.seo.title
					// 获取到所有的meta标签 (在public文件夹中的 index.html中 一般新建项目是没有关键字和描述的 需要自己手动填写)
					const AllMeta = document.getElementsByTagName('meta')

					for (var i = 0; i < AllMeta.length; i++) {
						// keywords
						if (AllMeta[i].getAttribute('name') === 'keywords') {
							AllMeta[i].content = res.data.data.seo.keywords
						}
						// description
						if (AllMeta[i].getAttribute('name') === 'description') {
							AllMeta[i].content = res.data.data.seo.description
						}
					}
				} else {
					this.$message({
						showClose: true,
						message: '联系我们接口' + res.data.msg,
						type: 'error'
					})
				}
			})
					this.$axios.get("/api/Index/linksAndAddress").then((res) => {
					if (res.data.code === 1) {
						// 地图上显示的卡片
						this.item_detailsArr = res.data.data.addressCard;

					} else {
						this.$message({
							showClose: true,
							message: "地图，" + res.data.msg,
							type: "error",
						});
					}
				});
			this.$axios.get("/apien/Index/linksAndAddress").then((res) => {
					if (res.data.code === 1) {
						// 地图上显示的卡片
						this.item_detailsArrE = res.data.data.addressCard;
					} else {
						this.$message({
							showClose: true,
							message: "地图，" + res.data.msg,
							type: "error",
						});
					}
				});
		},
		methods: {


		}
	}
</script>
<!-- 头部 -->
<style lang="less">
	.chinaEuropeTrain {
		background-color: #FFFFFF;
	}

	.TopTitle {

		width: 92%;
		height: 4.95rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;
		border-bottom: 1px solid rgba(204, 204, 204, .5);

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 3.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(
270deg,rgba(3,0,0,.15),hsla(0,0%,100%,.15));
		}
	}

	.ContentText {
		width: 92%;
		margin: 0 4%;
		// background-color: #000066;
		margin-top: -1.575rem;
		text-align: left;

		&>p {
			font-size: 0.875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-indent: 2em;
			margin-bottom: 1.25rem;
			text-align: justify;
		}
	}
</style>

<style lang="less">
	.ContentContactUs {
		width: 92%;
		margin: 0 4%;

		.main_items {
			width: 100%;
			// height: 17.03125rem;
			// background: pink;
			transition: all .35s;
			margin-bottom: 1.59375rem;

			.items_title {
				width: 100%;
				height: 2.5rem;
				background: #5289D1 linear-gradient(90deg, rgba(3, 0, 0, 0.15), rgba(255, 255, 255, 0.15));
				text-align: left;
				display: flex;
				align-items: center;
				justify-content: space-between;
				position: relative;

				.title_l {
					display: flex;
					align-items: center;

					& .rowLine {
						width: 7.5px;
						height: 2px;
						background: #FFFFFF;
						margin: 0 15px;
					}

					& p {
						font-size: 0.6875rem;
						font-family: Microsoft YaHei;
						font-weight: bold;
						color: #FFFFFF;
					}
				}

				.title_r {
					// background: orange;
					width: 8.15625rem;
					height: 3.5625rem;
					position: absolute;
					bottom: 0;
					right: 0px;

					&>img {
						width: 100%;
						height: 100%;
					}
				}

			}

			.item_details {
				width: 100%;
				height: calc(100% - 80px);
				background: #fff;
				padding: 0 20px 15px 18px;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				justify-content: center;
				box-shadow: 0px 0px 14px 0px rgba(4, 0, 0, 0.1);

				& p {
					margin-left: 15px;
				}

				& .pFont {
					font-size: 14px;
					font-family: Microsoft YaHei;
					text-align: left;
				}

				.weizhi {
					display: flex;
					align-items: center;
					margin-top: 1.09375rem;

					img {
						width: 0.59375rem;
						height: 0.71875rem;
					}

					p {
						font-size: 0.6875rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #666666;
					}
				}

				.emails {
					display: flex;
					align-items: center;
					margin-top: 1.1875rem;

					img {
						width: 0.625rem;
						height: 8.5px;
					}

					p {
						font-size: 0.6875rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #707070;
					}

				}

				.phones {
					display: flex;
					align-items: center;
					margin-top: 0.9375rem;
					margin-bottom: 1rem;

					img {
						width: 0.5625rem;
						height: 0.5625rem;
					}

					p {
						font-size: 0.9375rem;
						font-family: AkzidenzGroteskBQ;
						font-weight: normal;
						color: #2D6AAB;
					}
				}

			}


			// &:hover {
			// 	transform: translateY(-15px);
			// }
		}
	}

	// 小标题
	.tableTitleTitle {
		// margin: 1.875rem 0 0.625rem 0;
		font-size: 0.75rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #2E67B1;
		text-align: left;
		margin-bottom: 0.9375rem;
	}

	.buttonImg {
		width: 100%;
		height: 4rem;
		z-index: -1;

		&>img {
			width: 100%;
			height: 100%;
		}

	}
</style>
